import { Box, Checkbox, FormControlLabel, FormGroup, Switch, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { fetchPrivacySettings, savePrivacySettings } from '../logic/apiClass';

const PrivacySettingsPopup = ({ showPopup, handleCloseModal, safeAPId, toggleSafeApPrivacy, isSafeApPrivate }) => {

    const [loading, setLoading] = useState(true)
    const [submitLoading, setSubmitLoading] = useState(false)

    const [formDataFields, setFormDataFields] = useState([])
    const [privacySettings, setPrivacySettings] = useState([])
    const [message, setMessage] = useState("")
    useEffect(() => {
        if (showPopup) {
            setLoading(true)
            setFormDataFields([])
            setPrivacySettings([])
            setMessage("")
        }
    }, [showPopup])

    useEffect(() => {
        if (loading) {
            //fetch data
            fetchPrivacySettings(safeAPId, setLoading, setFormDataFields, setPrivacySettings)
        }
    }, [loading])

    useEffect(() => {
        if (!submitLoading) {
            setLoading(true)
        }
    }, [submitLoading])

    return (
        <Modal
            show={showPopup}
            size="xl"
            // backdrop="static"
            keyboard={false}
            onHide={handleCloseModal}
            // onBackdropClick={handleCloseModal}
            centered
            scrollable
            style={{ zIndex: 10000 }}
        >

            <Modal.Header>
                <h5>
                    Would you like to make your profile public?
                </h5>
                {message}
            </Modal.Header>

            <Modal.Body>

                {/* <FormControlLabel
                    value="privacy switch"
                    control={}
                    label={
                        
                    }
                    labelPlacement='start'
                /> */}
                <Typography>
        
                    {/* Show Profile in Public Directory(not live yet):  */}
                    Show Profile in Public Directory: 
                    <Switch color="primary" checked={!isSafeApPrivate} onChange={toggleSafeApPrivacy} />
                </Typography>
                {/* <br /> */}
                <Typography variant='overline'>By enabling the switch, your name, email and city would be visible in the directory by default</Typography>

                {
                    (loading || submitLoading) ?
                        <Box><Spinner size='sm' variant='primary' /> Fetching data from server</Box> :
                        <Box>
                            {
                                !isSafeApPrivate &&
                                <CheckBoxList choicesArray={formDataFields} selectedArray={privacySettings} setSelectedArray={setPrivacySettings} />
                            }

                        </Box>
                }

            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" disabled={loading || (!formDataFields || formDataFields.length === 0)}
                    onClick={() => {
                        setSubmitLoading(true)
                        savePrivacySettings(safeAPId, privacySettings, setSubmitLoading, setMessage)
                    }}
                >
                    Update Privacy settings
                </Button>
                <Button variant="secondary" onClick={() => {

                    handleCloseModal()
                }}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

const CheckBoxList = ({ choicesArray, selectedArray, setSelectedArray }) => {
    // console.log(choicesArray)

    const handleChange = (event) => {
        const tempArray = [...selectedArray]
        if (event.target.checked) {
            if (!tempArray.includes(event.target.name)) {
                tempArray.push(event.target.name)
            }
        } else {
            const index = tempArray.indexOf(event.target.name);
            if (index > -1) { // only splice array when item is found
                tempArray.splice(index, 1); // 2nd parameter means remove one item only
            }
        }
        setSelectedArray(tempArray)
    };
    const renderedCheckBoxes = () => {
        if (!choicesArray || choicesArray.length === 0) {
            return "Nothing to show"
        }

        return (
            <FormGroup>

                {choicesArray.map((choice, i) => {
                    return (
                        <FormControlLabel key={i}
                            control={
                                < Checkbox checked={selectedArray.includes(choice.key)} onChange={handleChange} name={choice.key} />
                            }
                            label={choice.title}
                        />)
                })}
            </FormGroup>
        )
    }

    return (<Box>
        {renderedCheckBoxes()}
    </Box>)
}


export default PrivacySettingsPopup;